import React from 'react';

import styles from 'styles/components/radio.scss';

const Radio = props => (
  <div className={styles.radio}>
    <input
      type="radio"
      {...props}
      className={styles.radioInput}
    />
    <div className="mdl-radio">
      <span className="mdl-radio__outer-circle" />
      <span className="mdl-radio__inner-circle" />
    </div>
  </div>
);

export default Radio;
